import { Fragment } from "preact";

import formatOdd from "../../../services/odds-format";
import * as I from "../utils/icons";

export function TournamentHeader({sport, category, onClose}) {
	return <div class="fn-tournament-crumb flex h-9 w-full items-center border-b border-harif-950 bg-harif-800 text-white">
		<div class="relative h-full w-9 bg-grapthie border-r border-harif-950 text-white flex items-center justify-center" onClick={onClose}>
		  <I.BackIconLarge class="h-4" />
		</div>
		<div class="px-4 text-sm">{sport.name}<span class="px-2 text-xs text-harifzinc-500">/</span>{category.name}</div>
	</div>
}

export function TournamentInfo({tournament, onClose}) {
	return <div class="fn-tournament-crumb flex h-9 w-full items-center justify-between border-b border-harif-950 bg-harif-800 text-white">
	  <div class="px-2 text-sm">{tournament.name}</div>
	  <div class="px-4">{/*Qui andrebbe la scelta del mercato*/}</div>
	</div>
}


export function TournamentDatesHeader({children}) {
	return <div class="fn-tournament-dates-header h-6 w-full border-b border-harif-950  bg-harif-800 text-white">
		<div class="flex h-full w-full items-center justify-between">
			{children}
			<div class="hidden w-14 shrink-0 grow-0 text-center text-xs sm:block"></div>
		</div>
	</div>
}
export function TournamentHeaderRow({children}) {
	return <div class="fn-tournament-dates-header h-6 w-full border-b  border-harif-950  bg-harif-800 text-white">
		{children}
	</div>
}
export function TournamentRowContent({children}) {
	return <div class="flex h-full w-full items-center justify-between">
		{children}
	</div>
}


export function TournamentDate({children}) {
	return <div class="min-w-0 grow px-2 text-xs truncate">{children}</div>
}
export function TournamentName({children}) {
	return <div class="min-w-0 grow text-sm truncate">{children}</div>
}

export function OutcomeNameHeader({children}) {
	return <div class="w-14 shrink-0 grow-0 text-center text-xs truncate">{children}</div>
}

export function MatchRow({children}) {
	return <div class="fn-event-row-mobile h-18 w-full overflow-x-auto scrollbar-hide border-t border-t-harif-800  border-b border-b-harif-950 bg-harif-900 text-slate-950 dark:text-white">
		<div class="w-full-14 sm:w-full flex h-full items-stretch justify-between">
			{children}
		</div>
	</div>;
}
export function FixedMatchRow({children, active}) {
	const baseClass = "fn-event-row-mobile h-18 w-full border-b border-b-harif-900 bg-harif-800 text-white flex h-full items-stretch justify-between cursor-pointer";
	if (active)
		return <div class={baseClass}>
			{children}
		</div>;
	return <div class={baseClass + " hover:bg-harifzinc-800"}>
		{children}
	</div>;
}

export function MatchInfo({children, ...props}) {
	return <div class="flex min-w-0 grow flex-col justify-between overflow-x-hidden overflow-y-hidden px-2 py-1 text-sm" {...props}>
		{children}
	</div>
}

export function MatchInfoWithVisibleOverflow({children, ...props}) {
	return <div class="flex min-w-0 grow flex-col justify-between px-2 py-1 text-sm" {...props}>
		{children}
	</div>
}
export function StatsCell({children}) {
	return <div class="w-6 shrink-0 grow-0 text-center text-xs flex items-center border-r border-harif-950 justify-center ">{children}</div>
}
export function Teams({children}) {
	return <div>{children}</div>;
}
export function TeamWithScore({children}) {
	return <div class="flex items-center">{children}</div>
}
export function HomeTeamName({children}) {
	return <div class="fn-home-team-name truncate grow font-bold text-base">{children}</div>
}
export function AwayTeamName({children}) {
	return <div class="fn-home-team-name truncate grow font-bold text-base">{children}</div>
}
export function ScoreElement({children}) {
	return <div class="bg-custom-orange-dark text-sm text-white font-bold flex-none w-5 h-5 leading-none flex items-center justify-center">{children}</div>
}
export function MatchTime({children}) {
	return <div class="fn-start-time text-xs">{children}</div>
}

export function OddButtonCell({children}) {
	return <div class="w-14 shrink-0 grow-0 text-center text-xs  border-r border-harif-950">{children}</div>
}
export function OddButton({value, active, onClick, selected, useLock = false}) {
	if (selected)
		return <div 
				   class="fn-odd-btn bg-custom-orange text-black flex h-full w-full items-center justify-center text-base font-bold" 
				   onClick={onClick}
				   >
			{!!value ? formatOdd(value) : (!useLock ? '-' : <>
				<I.LockIcon class="h-3" />
			</>)}
		</div>
	return <div 
			   class="fn-odd-btn text-custom-orange-dark dark:text-custom-orabg-custom-orange flex h-full w-full items-center justify-center text-base font-bold" 
			   onClick={onClick}>
		{!!value ? formatOdd(value) : (!useLock ? '-' : <>
			<I.LockIcon class="h-3" />
		</>)}
	</div>
}
export function StarCell({children, selected, onClick}) {
	return <div class="w-14 shrink-0 grow-0 text-center text-xs flex items-center justify-center" onClick={onClick}>{children}</div>
}

export function FakeSeparator() {
	return <div class="fn-fake-rail h-2 w-full border-b border-slate-200 bg-slate-100 dark:border-slate-900 dark:bg-slate-800"></div>;
}

function TournamentCardExample() {
	return <Fragment>
		<TournamentHeader sport={{name:"Football"}} category={{name: "World"}} onClose={() => {}} />
		<TournamentInfo tournament={{name: "Premier League"}} />
		<TournamentDatesHeader>
			<TournamentDate>Sunday, April 09, 2023</TournamentDate>
			<OutcomeNameHeader>1</OutcomeNameHeader>
			<OutcomeNameHeader>X</OutcomeNameHeader>
			<OutcomeNameHeader>2</OutcomeNameHeader>
		</TournamentDatesHeader>
		<MatchRow>
			<MatchInfo>
				<Teams>
					<HomeTeamName>Home Home Home Home Home Home Home Home Home Home Home Home Home</HomeTeamName>
					<AwayTeamName>Away</AwayTeamName>
				</Teams>
				<MatchTime>21:00</MatchTime>
			</MatchInfo>
			<OddButtonCell>
				<OddButton>2.10</OddButton>
			</OddButtonCell>
			<OddButtonCell>
				<OddButton>2.10</OddButton>
			</OddButtonCell>
			<OddButtonCell>
				<OddButton>2.10</OddButton>
			</OddButtonCell>
			<StarCell>Fv</StarCell>
		</MatchRow>
		<FakeSeparator />
	</Fragment>
}



export function EventCard({children}) {
	return <div class="border-b border-t fn-event-row-mobile w-full border-b-slate-300 bg-slate-100 border-t-slate-200 text-slate-950 dark:border-b-slate-900 dark:bg-slate-800 dark:border-t-slate-800 dark:text-white">{children}</div>
}


export function EventInfoRow({children, onClick}) {
	return <div class="border-b flex flex-col grow justify-between min-w-0 overflow-x-hidden text-xs border-b-slate-200 dark:border-b-slate-900" onClick={onClick}>
		{children}
	</div>
}

export function EventTeams({children}) {
	return <div class="flex h-10 items-center justify-between px-2 w-full">{children}</div>
}
export function TeamHolder({children}) {
	return <div class="flex fn-home-team-name items-center truncate gap-1">{children}</div>
}
export function TeamName({children}) {
	return <span>{children}</span>
}
export function TeamSymbol({children, side}) {
	return <span class="h-6 w-6 px-0.5 flex items-center">
		{side == 'home' 
			? <I.ShirtSvg class="w-full [--shirt-stripe-color:#d00] fill-white" />
			: <I.ShirtSvg class="w-full [--shirt-stripe-color:#fff] fill-blue-600" />}
	</span>
}

export function EventFullDate({children}) {
	return <div class="border-t fn-start-time py-1 text-center text-xxs w-full border-slate-200 bg-slate-200 dark:bg-slate-900 dark:border-slate-900">{children}</div>
}



export function MatchMarkets({children}) {
	return <div class="bg-slate-300 dark:bg-slate-900">{children}</div>
}

export function MarketContainer({children}) {
	return <div class="fn-market-row">{children}</div>
}

export function MarketTitle({children}) {
	return <div class="px-1 py-0.5 text-xxs uppercase">{children}</div>
}

export function OddButtonsGrid({children, cols}) {
	if (cols == 3) {
		return <div class="bg-slate-300 dark:bg-slate-900 fn-market-odds grid grid-cols-3">{children}</div>
	}
	return <div class="bg-slate-300 dark:bg-slate-900 fn-market-odds grid grid-cols-2">{children}</div>
}
export function OddButtonFull({children, onClick, selected}) {
	if (selected)
		return <div class={"bg-amber-500 border flex h-full items-center justify-between text-black border-b-slate-300 border-l-slate-200 border-r-slate-300 border-t-slate-200"
			+" dark:border-b-slate-950 dark:border-l-slate-800 dark:border-r-slate-950 dark:border-t-slate-800"
		} onClick={onClick}>
			{children}
		</div>
	return <div class={"border flex h-full items-center justify-between text-slate-950 bg-slate-100 border-b-slate-300 border-l-slate-200 border-r-slate-300 border-t-slate-200"+
		" dark:text-white dark:bg-slate-800 dark:border-b-slate-950 dark:border-l-slate-800 dark:border-r-slate-950 dark:border-t-slate-800"
	} onClick={onClick}>
		{children}
	</div>
}
export function OddName({children}) {
	return <div class="truncate px-2 text-xs">{children}</div>
}
export function OddValue({children, value, selected}) {
	if (selected)
		return <div class="px-2 text-base text-black">{!!value ? formatOdd(value) : '-'}</div>
	return <div class="px-2 text-base text-amber-500">{!!value ? formatOdd(value) : '-'}</div>
}



function TournamentEventExtended() {
	return <EventCard>
		<EventInfoRow>
			<EventTeams>
				<TeamHolder>
					<TeamSymbol />
					<TeamName>USD Lavagnese 1919</TeamName>
				</TeamHolder>
				<TeamHolder>
					<TeamName>USD Sestri Levante</TeamName>
					<TeamSymbol />
				</TeamHolder>
			</EventTeams>
			<EventFullDate>17/8/2023 18:00:00</EventFullDate>
		</EventInfoRow>
		<MatchMarkets>
			<MarketContainer>
				<MarketTitle>1x2</MarketTitle>
				<OddButtonsGrid>
					<OddButtonFull>
						<OddName>Local</OddName>
						<OddValue value={3.82} />
					</OddButtonFull>
					<OddButtonFull>
						<OddName>Empate</OddName>
						<OddValue>3.80</OddValue>
					</OddButtonFull>
					<OddButtonFull>
						<OddName>Visitante</OddName>
						<OddValue>1.74</OddValue>
					</OddButtonFull>
				</OddButtonsGrid>
			</MarketContainer>
			<FakeSeparator />
		</MatchMarkets>
	</EventCard>
}